/* tslint:disable */
/* eslint-disable */
export enum WorkTaskChangeRequestStatusEnum {
  Pending = 'PENDING',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED'
}
